import { render, staticRenderFns } from "./BaseEChartPie.vue?vue&type=template&id=65650f8e&scoped=true"
import script from "./BaseEChartPie.vue?vue&type=script&lang=js"
export * from "./BaseEChartPie.vue?vue&type=script&lang=js"
import style0 from "./BaseEChartPie.vue?vue&type=style&index=0&id=65650f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65650f8e",
  null
  
)

export default component.exports